/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/pet-care': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.364 9.89c1.677 0 3.24.854 4.145 2.266l2.492 3.888a2.87 2.87 0 01-3.57 4.175 7.62 7.62 0 00-6.134 0 2.87 2.87 0 01-3.57-4.175l2.492-3.888a4.924 4.924 0 014.145-2.267zm6.467.698c.858-1.158 2.351-1.504 3.339-.775.984.73 1.09 2.26.233 3.418-.857 1.158-2.353 1.505-3.338.775-.985-.729-1.09-2.26-.234-3.418zM3.338 6.913c1.145-.441 2.493.292 3.01 1.636.518 1.344.01 2.792-1.136 3.232-1.144.441-2.492-.292-3.01-1.636-.517-1.345-.008-2.792 1.136-3.232zm9.85-.486c.552-1.663 2.15-2.63 3.565-2.16 1.416.47 2.117 2.201 1.563 3.864-.552 1.663-2.15 2.63-3.565 2.159-1.416-.47-2.116-2.2-1.563-3.863zM9.712 3c1.492 0 2.702 1.421 2.702 3.174 0 1.752-1.21 3.173-2.702 3.173S7.009 7.926 7.009 6.174C7.01 4.42 8.22 3 9.712 3z" _fill="#000" fill-rule="evenodd"/>'
  }
})
